var _style, _path, _path2, _path3, _path4, _path5, _g, _polygon, _polygon2, _path6, _path7, _path8, _path9, _path0, _line, _polyline, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _line2, _polygon3, _polygon4, _polygon5, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _line11, _line12, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg404ErrorPage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 653 472",
    style: {
      enableBackground: "new 0 0 653 472"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#8E7EAC;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#2648B2;}\n\t.st2{fill:none;stroke:#0C1F28;stroke-width:10;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#0C1F28;}\n\t.st5{fill:none;stroke:#0C1F28;stroke-width:10;stroke-linecap:round;stroke-linejoin:round;}\n\t.st6{fill:none;stroke:#0C1F28;stroke-width:10;stroke-linejoin:round;}\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#FF0085;}\n\t.st8{fill:none;stroke:#FFFFFF;stroke-width:3;}\n\t.st9{fill:none;stroke:#0C1F28;stroke-width:6;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M626.2,211c4.3,0,7.7-3.5,7.7-7.7v-22.7v-0.1L591.3,211H626.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M591,211l-42.6-30.5v0.1v22.7c0,4.2,3.4,7.7,7.7,7.7H591z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M486.5,425.5c-4.3,0-7.7-3.5-7.7-7.7V395v-0.1l42.6,30.6H486.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M555.3,425.5c4.3,0,7.7-3.5,7.7-7.7V395v-0.1l-42.6,30.6H555.3z M28.4,211c-4.3,0-7.7-3.5-7.7-7.7v-22.7v-0.1 L63.3,211H28.4z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M97.2,211c4.3,0,7.7-3.5,7.7-7.7v-22.7v-0.1L62.3,211H97.2z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M62.1,92.8v117.7c0,18.4,14.9,33.4,33.4,33.4h3.7h130"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.9,243.9h130h3.7c18.4,0,33.4-14.9,33.4-33.4V92.8"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "227.7,309.5 426.1,309.5 426.1,183.6 227.7,183.6 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "239.8,297.4 414,297.4 414,195.7 239.8,195.7 "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M292.5,277.7c-4.3,0-7.7-3.5-7.7-7.7v-22.7v-0.1l42.6,30.6L292.5,277.7L292.5,277.7z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M361.3,277.7c4.3,0,7.7-3.5,7.7-7.7v-22.7v-0.1l-42.6,30.6L361.3,277.7L361.3,277.7z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M292.5,240.5c-4.3,0-7.7-3.5-7.7-7.7v-22.7V210l42.6,30.6h-34.9V240.5z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M361.3,240.5c4.3,0,7.7-3.5,7.7-7.7v-22.7V210l-42.6,30.6h34.9V240.5z M426.6,172.7c-4.5-11-8.2-14.7-19.2-19.2 c11-4.5,14.7-8.2,19.2-19.2c4.5,11,8.2,14.7,19.2,19.2C434.9,158.1,431.2,161.8,426.6,172.7"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M446.8,169.3c3.2,0,5.8,2.6,5.8,5.8s-2.6,5.8-5.8,5.8c-3.2,0-5.8-2.6-5.8-5.8 C441,171.9,443.6,169.3,446.8,169.3"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 326.9,
    y1: 297.4,
    x2: 326.9,
    y2: 81.4
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "st5",
    points: "482.2,145.1 482.2,27.5 426.6,111.9 497.8,111.9 "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M420.8,243.9h28c18.4,0,33.4-14.9,33.4-33.4v-65.4"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M399.4,72.5c0,40.1-32.5,72.5-72.5,72.5c-40.1,0-72.5-32.5-72.5-72.5S286.8,0,326.9,0 C366.9,0,399.4,32.5,399.4,72.5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M355.3,37c0,15.7-12.7,28.4-28.4,28.4S298.5,52.7,298.5,37s12.7-28.4,28.4-28.4S355.3,21.3,355.3,37  M355.3,107.6c0,15.7-12.7,28.4-28.4,28.4s-28.4-12.7-28.4-28.4s12.7-28.4,28.4-28.4S355.3,91.9,355.3,107.6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M291.6,43.9c15.7,0,28.4,12.7,28.4,28.4s-12.7,28.4-28.4,28.4c-15.7,0-28.4-12.7-28.4-28.4 S275.9,43.9,291.6,43.9 M362.2,43.9c15.7,0,28.4,12.7,28.4,28.4s-12.7,28.4-28.4,28.4S333.8,88,333.8,72.3S346.5,43.9,362.2,43.9"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M357.1,74.9c0,16.7-13.5,30.2-30.2,30.2s-30.2-13.5-30.2-30.2s13.5-30.2,30.2-30.2S357.1,58.2,357.1,74.9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M340.1,74.9c0,7.3-5.9,13.2-13.2,13.2s-13.2-5.9-13.2-13.2s5.9-13.2,13.2-13.2S340.1,67.6,340.1,74.9  M364.2,111.9c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3C366.1,116.2,364.2,114.3,364.2,111.9 M279.8,31.8 c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3C281.8,36.2,279.8,34.2,279.8,31.8 M364.2,31.8c0-2.4,1.9-4.3,4.3-4.3 s4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3C366.1,36.2,364.2,34.2,364.2,31.8 M279.8,111.9c0-2.4,1.9-4.3,4.3-4.3s4.3,1.9,4.3,4.3 s-1.9,4.3-4.3,4.3C281.8,116.2,279.8,114.3,279.8,111.9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M263.2,297.4v-20.2c0-18.4-14.9-33.4-33.4-33.4c-18.4,0-33.4,14.9-33.4,33.4v117.7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M263.2,145.3c0-18.4-14.9-33.4-33.4-33.4h-4.6h-71.3l55.6-84.4v117.6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 263.2,
    y1: 297.4,
    x2: 263.2,
    y2: 145.3
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "308.6,331.8 345.1,331.8 345.1,309.5 308.6,309.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "227.7,394.9 426.1,394.9 426.1,327.1 227.7,327.1 "
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "239.8,384.5 414,384.5 414,337.5 239.8,337.5 "
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.8,
    y1: 368.8,
    x2: 414,
    y2: 368.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 239.8,
    y1: 353.2,
    x2: 414,
    y2: 353.2
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 396.6,
    y1: 368.8,
    x2: 396.6,
    y2: 384.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 396.6,
    y1: 337.5,
    x2: 396.6,
    y2: 368.8
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 379.1,
    y1: 337.5,
    x2: 379.1,
    y2: 384.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 361.7,
    y1: 337.5,
    x2: 361.7,
    y2: 384.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 326.9,
    y1: 337.5,
    x2: 326.9,
    y2: 368.8
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 309.5,
    y1: 337.5,
    x2: 309.5,
    y2: 368.8
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 292,
    y1: 337.5,
    x2: 292,
    y2: 384.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 274.6,
    y1: 337.5,
    x2: 274.6,
    y2: 384.5
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 257.2,
    y1: 337.5,
    x2: 257.2,
    y2: 384.5
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "st8",
    x1: 344.3,
    y1: 337.5,
    x2: 344.3,
    y2: 368.8
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M125.7,111.9c0,34.7-28.1,62.8-62.8,62.8C28.1,174.7,0,146.6,0,111.9s28.1-62.8,62.8-62.8 C97.5,49.1,125.7,77.2,125.7,111.9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.8,154.5c-23.5,0-42.6-19.1-42.6-42.6s19.1-42.6,42.6-42.6s42.6,19.1,42.6,42.6 C105.4,135.4,86.3,154.5,62.8,154.5"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.3,138.9c0,5.5-4.3,10-9.5,10s-9.5-4.5-9.5-10v-54c0-5.5,4.3-10,9.5-10s9.5,4.5,9.5,10V138.9z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M89.8,102.4c5.5,0,10,4.3,10,9.5s-4.5,9.5-10,9.5h-54c-5.5,0-10-4.3-10-9.5s4.5-9.5,10-9.5H89.8z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M50.4,137.7c-3.9,3.9-10.1,4-13.8,0.3s-3.5-9.9,0.3-13.8L75.1,86c3.9-3.9,10.1-4,13.8-0.3 c3.7,3.7,3.5,9.9-0.3,13.8L50.4,137.7z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.7,124.3c3.9,3.9,4,10.1,0.3,13.8s-9.9,3.5-13.8-0.3L37,99.5c-3.9-3.9-4-10.1-0.3-13.8 c3.7-3.7,9.9-3.5,13.8,0.3L88.7,124.3z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M62.8,134.3c-12.3,0-22.4-10-22.4-22.4s10-22.4,22.4-22.4c12.3,0,22.4,10,22.4,22.4S75.2,134.3,62.8,134.3"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M62.8,120.1c-4.5,0-8.2-3.7-8.2-8.2s3.7-8.2,8.2-8.2s8.2,3.7,8.2,8.2S67.3,120.1,62.8,120.1 M140.2,220.4 c4.5-11,8.2-14.7,19.2-19.2c-11-4.5-14.7-8.2-19.2-19.2c-4.5,11-8.2,14.7-19.2,19.2C132,205.8,135.7,209.4,140.2,220.4"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M120,216.9c-3.2,0-5.8,2.6-5.8,5.8s2.6,5.8,5.8,5.8c3.2,0,5.8-2.6,5.8-5.8S123.2,216.9,120,216.9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M95.4,425.5c-4.3,0-7.7-3.5-7.7-7.7V395v-0.1l42.6,30.6H95.4z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M164.1,425.5c4.3,0,7.7-3.5,7.7-7.7V395v-0.1l-42.6,30.6H164.1z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M129.8,315.4v117.7c0,18.4,14.9,33.4,33.4,33.4s33.4-14.9,33.4-33.4V315.4 M520.9,384.5v48.6 c0,18.4-14.9,33.4-33.4,33.4c-18.4,0-33.4-14.9-33.4-33.4v-38.2V277.2c0-18.4-14.9-33.4-33.4-33.4c-18.4,0-33.4,14.9-33.4,33.4v20.2 "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M129.2,394.9c-26.6,0-48.3-21.7-48.3-48.3c0-26.6,21.7-48.3,48.3-48.3s48.3,21.7,48.3,48.3 C177.6,373.2,155.9,394.9,129.2,394.9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M140,373.6c0,8.2-4.9,15-10.8,15c-5.9,0-10.8-6.8-10.8-15v-54c0-8.2,4.9-15,10.8-15c5.9,0,10.8,6.8,10.8,15 V373.6z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156.3,335.8c8.2,0,15,4.9,15,10.8s-6.8,10.8-15,10.8h-54c-8.2,0-15-4.9-15-10.8s6.8-10.8,15-10.8H156.3z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M117.8,373.3c-5.8,5.8-14,7.2-18.2,3s-2.9-12.4,3-18.2l38.2-38.2c5.8-5.8,14-7.2,18.2-3s2.9,12.4-3,18.2 L117.8,373.3z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M156,358c5.8,5.8,7.2,14,3,18.2s-12.4,2.9-18.2-3L102.6,335c-5.8-5.8-7.2-14-3-18.2s12.4-2.9,18.2,3L156,358z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M129.2,371.9c-14,0-25.4-11.4-25.4-25.4s11.4-25.4,25.4-25.4s25.4,11.4,25.4,25.4 C154.6,360.6,143.2,371.9,129.2,371.9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M129.2,355.9c-5.1,0-9.3-4.2-9.3-9.3c0-5.1,4.2-9.3,9.3-9.3s9.3,4.2,9.3,9.3 C138.5,351.7,134.4,355.9,129.2,355.9"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M569.7,346.6c0,26.7-21.6,48.3-48.3,48.3s-48.3-21.6-48.3-48.3s21.6-48.3,48.3-48.3 C548.1,298.2,569.7,319.9,569.7,346.6"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M521.4,298.2c-26.6,0-48.2,21.5-48.3,48.1h96.6C569.6,319.8,548,298.2,521.4,298.2"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M540.3,322.9c0,10.4-8.5,18.9-18.9,18.9c-10.4,0-18.9-8.5-18.9-18.9S511,304,521.4,304 C531.8,304,540.3,312.4,540.3,322.9 M540.3,369.9c0,10.4-8.5,18.9-18.9,18.9c-10.4,0-18.9-8.5-18.9-18.9S511,351,521.4,351 C531.8,351,540.3,359.5,540.3,369.9"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M497.9,327.5c10.4,0,18.9,8.5,18.9,18.9s-8.5,18.9-18.9,18.9s-18.9-8.5-18.9-18.9S487.4,327.5,497.9,327.5  M544.9,327.5c10.4,0,18.9,8.5,18.9,18.9s-8.5,18.9-18.9,18.9s-18.9-8.5-18.9-18.9S534.5,327.5,544.9,327.5"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M541.5,346.6c0,11.1-9,20.1-20.1,20.1c-11.1,0-20.1-9-20.1-20.1s9-20.1,20.1-20.1 C532.5,326.5,541.5,335.5,541.5,346.6"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M530.2,346.6c0,4.9-3.9,8.8-8.8,8.8c-4.9,0-8.8-3.9-8.8-8.8s3.9-8.8,8.8-8.8 C526.2,337.8,530.2,341.7,530.2,346.6"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M653,111.9c0,34.7-28.1,62.8-62.8,62.8s-62.8-28.1-62.8-62.8s28.1-62.8,62.8-62.8S653,77.2,653,111.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M590.2,154.5c-23.5,0-42.6-19.1-42.6-42.6s19.1-42.6,42.6-42.6s42.6,19.1,42.6,42.6S613.7,154.5,590.2,154.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M590.2,134.3c-12.3,0-22.4-10-22.4-22.4c0-12.3,10-22.4,22.4-22.4c12.3,0,22.4,10,22.4,22.4 C612.5,124.2,602.5,134.3,590.2,134.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 590.2,
    y1: 98.2,
    x2: 590.2,
    y2: 124.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 577.1,
    y1: 111.2,
    x2: 603.2,
    y2: 111.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 599.4,
    y1: 102,
    x2: 580.9,
    y2: 120.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st9",
    x1: 580.9,
    y1: 102,
    x2: 599.4,
    y2: 120.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg404ErrorPage);
export default __webpack_public_path__ + "static/media/404-error-page.4a37e6877f864022c4f9f1046096a8fa.svg";
export { ForwardRef as ReactComponent };